import { tourTypes, TripTypes } from '@model/common/tours/trip-types';
import { Name } from '@model/iceberg';
import moment from 'moment';

const UPDATE_FROM_MONTH: number = 8;

const getNext = (value: number) => value + 1;

const getYearDates = () => {
  const currentDate = moment();
  const currentMonth = currentDate.month();

  const baseYear = currentMonth >= UPDATE_FROM_MONTH ? getNext(currentDate.year()) : currentDate.year();

  return {
    from: baseYear,
    to: getNext(baseYear)
  };
};

export function getDestinationMetaTitle(destination: Name, type: TripTypes, t: any): string {
  const { from, to } = getYearDates();

  const translationKey = tourTypes.includes(type)
    ? `seo__${type.toLowerCase()}-destination--title`
    : 'seo__destination-page--title';

  return t(translationKey, {
    destination: destination.display,
    from,
    to
  });
}

export function getDestinationMetaDescription(destination: Name, type: TripTypes, t: any): string {
  const title = destination.display;
  switch (type) {
    case TripTypes.ESCORTED_TOURS:
      return t('seo__tour-destination--description', { destination: title });
    case TripTypes.PRIVATE_TOURS:
      return t('seo__private-tour-destination--description', { destination: title });
    case TripTypes.RAIL_JOURNEYS:
      return t('seo__rail-journeys-destination--description', { destination: title });
    case TripTypes.RIVER_CRUISES:
      return t('seo__river-cruises-destination--description', { destination: title });
    case TripTypes.FLY_DRIVES:
      return t('seo__fly-drives-destination--description', { destination: title });
    case TripTypes.WALKING_ROUTES:
      return t('seo__walking-routes-destination--description', { destination: title });
    case TripTypes.MULTI_CENTRE:
      return t('seo__multicentres-destination--description', { destination: title });
    case TripTypes.CRUISES:
      return t('seo__cruises-destination--description', { destination: title });
    default:
      return t('seo__destination-page--description', { destination: title });
  }
}
